import { ScreenHeader } from '@components/v2/layout/ScreenHeader/ScreenHeader';
import { ScreenHeaderBreadcrumb } from '@components/v2/layout/ScreenHeader/components/ScreenHeaderBreadcrumb';
import { stickyScreenHeaderSx } from '@components/v2/layout/ScreenHeader/screenHeader.styles';
import { Box, Grid, Paper, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

import useWidth from './Hooks/useWidth';

const useStyles = makeStyles()((theme) => ({
  unnakedStyle: {
    height: `calc(100% - ${theme.spacing(4)})`,
  },
  content: {
    height: `calc(100% - ${theme.spacing(5)})`,
  },
}));

interface ListTemplateBaseProps {
  title?: string;
  naked?: boolean;
  goBackUrl?: string;
  renderFilter?: () => ReactNode;
  ActionButton?: ReactNode;
  gutterBottom?: boolean;
  titleWithGoBack?: boolean;
}

type ListTemplateProps =
  | (ListTemplateBaseProps & {
      Table: ReactNode;
      renderTable?: never;
    })
  | (ListTemplateBaseProps & {
      Table?: never;
      renderTable: () => ReactNode;
    });

export const ListTemplate = ({
  title,
  naked,
  Table,
  goBackUrl,
  renderFilter,
  renderTable,
  ActionButton,
  gutterBottom,
  titleWithGoBack,
}: ListTemplateProps) => {
  const { classes } = useStyles();
  const history = useHistory();

  const { mobileWidth } = useWidth();

  const gutterBottomValue = mobileWidth ? 9 : 13;
  const hasHeader = Boolean(title || goBackUrl);
  const hasGoBackButton = Boolean(titleWithGoBack || (mobileWidth && goBackUrl));

  const handleGoBack = () => {
    if (goBackUrl) {
      history.push(goBackUrl);
      return;
    }

    history.goBack();
  };

  const renderContent = () => (
    <Grid wrap="nowrap" container spacing={1} direction="column">
      {renderFilter && <Grid>{renderFilter()}</Grid>}
      <Grid size="grow">{Table ? Table : renderTable && renderTable()}</Grid>
    </Grid>
  );

  return (
    <Stack>
      {hasHeader && (
        <Box sx={stickyScreenHeaderSx}>
          <ScreenHeader
            actions={ActionButton}
            breadcrumb={
              <ScreenHeaderBreadcrumb
                items={title ? [{ label: title }] : []}
                hasGoBackButton={hasGoBackButton}
                onGoBack={handleGoBack}
              />
            }
          />
        </Box>
      )}

      <Box
        className={!naked ? classes.unnakedStyle : ''}
        sx={{
          padding: mobileWidth ? 1 / 2 : 0,
          paddingTop: hasHeader ? 1.5 : 0,
          paddingBottom: gutterBottom ? gutterBottomValue : 0,
        }}
      >
        <Stack className={classes.content}>
          {naked && renderContent()}
          {!naked && (
            <Paper elevation={0}>
              <Box
                sx={{
                  p: 2,
                }}
              >
                {renderContent()}
              </Box>
            </Paper>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};
